<template>
    <div>
        <svg
            v-if="name == 'submitSuccess'"
            t="1610351372202"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2050"
            :width="size"
            :height="size"
        >
            <path
                d="M512 0C229.668571 0 0 229.668571 0 512s229.668571 512 512 512 512-229.668571 512-512S794.331429 0 512 0z m307.2 343.771429s-267.702857 295.497143-327.68 365.714285c-59.977143 70.217143-106.788571 0-106.788571 0L210.651429 529.554286s-27.794286-42.422857 21.942857-81.92c46.811429-38.034286 84.845714 0 84.845714 0l122.88 128.731428L746.057143 291.108571s29.257143-20.48 59.977143 5.851429c23.405714 21.942857 13.165714 46.811429 13.165714 46.811429z"
                fill="#68BF7B"
                p-id="2051"
            ></path>
        </svg>

        <svg
            v-if="name == 'waitConfirm'"
            t="1610441984728"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2145"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M384 896 160 896c-52.9 0-96-43.1-96-96L64 160c0-52.9 43.1-96 96-96l512 0c52.9 0 96 43.1 96 96l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32L704 160c0-17.6-14.4-32-32-32L160 128c-17.6 0-32 14.4-32 32l0 640c0 17.6 14.4 32 32 32l224 0c17.7 0 32 14.3 32 32S401.7 896 384 896z"
                p-id="2146"
            ></path>
            <path
                d="M688 960c-72.7 0-141-28.3-192.3-79.7C444.3 829 416 760.7 416 688s28.3-141 79.7-192.3C547 444.3 615.3 416 688 416s141 28.3 192.3 79.7C931.7 547.1 960 615.4 960 688s-28.3 141-79.7 192.3S760.7 960 688 960zM688 480c-114.7 0-208 93.3-208 208s93.3 208 208 208 208-93.3 208-208S802.7 480 688 480z"
                p-id="2147"
            ></path>
            <path
                d="M800 768 672 768c-17.7 0-32-14.3-32-32L640 576c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128 96 0c17.7 0 32 14.3 32 32S817.7 768 800 768z"
                p-id="2148"
            ></path>
            <path d="M608 320 224 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32S625.7 320 608 320z" p-id="2149"></path>
            <path d="M384 512 224 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32S401.7 512 384 512z" p-id="2150"></path>
            <path d="M320 704l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32S337.7 704 320 704z" p-id="2151"></path>
        </svg>

        <svg
            v-if="name == 'reserveSuccess'"
            t="1610442211292"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2974"
            :fill="$primary"
            :width="size"
            :height="size"
        >
            <path
                d="M361.075707 479.186212l102.632541 102.399814 226.070861-226.070861a46.54537 46.54537 0 1 1 65.815154 65.815153L507.181623 669.76623a47.569368 47.569368 0 0 1-9.309074 13.96361 48.10464 48.10464 0 0 1-35.351208 13.963611 45.917007 45.917007 0 0 1-36.026116-13.032703 45.311918 45.311918 0 0 1-7.54035-11.35707l-126.254316-125.835408a48.314094 48.314094 0 0 1 68.375148-68.282058zM511.999069 1023.999767A511.999069 511.999069 0 0 1 0 512.000698a46.54537 46.54537 0 0 1 93.09074 0 419.536692 419.536692 0 1 0 155.926989-325.817589H325.817589a46.54537 46.54537 0 0 1 0 93.09074H139.63611a46.54537 46.54537 0 0 1-46.54537-46.54537h-9.890891c3.141812-4.840718 6.58617-9.471983 9.890891-14.196338V46.546999a46.54537 46.54537 0 0 1 93.09074 0v70.842053A511.999069 511.999069 0 1 1 511.999069 1023.999767z"
                p-id="2975"
            ></path>
        </svg>

        <svg
            v-if="name == 'reserveFail'"
            t="1610442310391"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3119"
            :fill="$primary"
            :width="size"
            :height="size"
        >
            <path
                d="M339.199383 339.061376a47.336641 47.336641 0 0 1 66.932242 0l117.131424 117.131424 117.131423-117.131424a47.336641 47.336641 0 0 1 66.932242 66.932242l-117.131423 117.131424 117.131423 117.131423a47.336641 47.336641 0 1 1-66.932242 66.932242l-117.131423-117.131423-117.131424 117.131423a47.336641 47.336641 0 0 1-66.932242-66.932242l117.131424-117.131423-117.131424-117.131424a47.336641 47.336641 0 0 1 0-66.932242zM511.999069 1023.999767A511.999069 511.999069 0 0 1 0 512.000698a46.54537 46.54537 0 0 1 93.09074 0 419.536692 419.536692 0 1 0 155.926989-325.817589H325.817589a46.54537 46.54537 0 0 1 0 93.09074H139.63611a46.54537 46.54537 0 0 1-46.54537-46.54537h-9.890891c3.141812-4.840718 6.58617-9.471983 9.890891-14.196338V46.546999a46.54537 46.54537 0 0 1 93.09074 0v70.842053A511.999069 511.999069 0 1 1 511.999069 1023.999767z"
                p-id="3120"
            ></path>
        </svg>

        <svg
            v-if="name == 'hotel'"
            t="1610503107305"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6377"
            :width="size"
            :height="size"
        >
            <path d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z" fill="#4565ED" p-id="6378"></path>
            <path d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z" fill="#D9EDFF" p-id="6379"></path>
            <path d="M885.1 760H138.9C219.1 880.6 356.3 960 512 960s292.9-79.4 373.1-200z" fill="#0285FF" p-id="6380"></path>
            <path d="M773.1 760h-240V392h220c11 0 20 9 20 20v348z" fill="#88C6FF" p-id="6381"></path>
            <path d="M662.3 759.7h-300v-440c0-11 9-20 20-20h260c11 0 20 9 20 20v440z" fill="#0285FF" p-id="6382"></path>
            <path
                d="M415 350h70v42h-70zM535 350h70v42h-70zM415 422h70v42h-70zM535 422h70v42h-70zM415 494h70v42h-70zM535 494h70v42h-70zM415 566h70v42h-70zM535 566h70v42h-70zM415 638h70v42h-70zM535 638h70v42h-70zM685 425h60v36h-60zM685 497h60v36h-60zM685 569h60v36h-60zM685 641h60v36h-60z"
                fill="#FFEC16"
                p-id="6383"
            ></path>
            <path d="M220.2 580h20v180h-20z" fill="#88C6FF" p-id="6384"></path>
            <path d="M161.8 611.2l68.4-62.2 68.3 62.2z" fill="#0285FF" p-id="6385"></path>
            <path d="M155.6 651.6l74.6-67.9 74.6 67.9z" fill="#0285FF" p-id="6386"></path>
            <path d="M147.8 696.1l82.4-75 82.3 75z" fill="#0285FF" p-id="6387"></path>
        </svg>

        <svg
            v-if="name == 'orderSuccess'"
            t="1610004405002"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7388"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M512 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z m193.472 301.696l-210.56 292.032a31.808 31.808 0 0 1-51.712 0l-124.672-172.8a8 8 0 0 1 6.464-12.736h46.912c10.24 0 19.84 4.928 25.92 13.312L468.992 584.32l157.184-218.048a32 32 0 0 1 25.92-13.248h46.912c6.464 0 10.24 7.36 6.464 12.672z"
                p-id="7389"
                :width="size"
                :height="size"
            ></path>
        </svg>

        <svg
            v-if="name == 'orderFail'"
            t="1610518641083"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2573"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M874.0352 149.9648c-199.953067-199.953067-524.1344-199.953067-724.0704 0-199.953067 199.953067-199.953067 524.1344 0 724.0704 199.953067 199.953067 524.1344 199.953067 724.0704 0 199.953067-199.953067 199.953067-524.117333 0-724.0704z m-194.56 481.245867c12.8512 12.8512 15.138133 33.9456 3.310933 47.752533a34.048 34.048 0 0 1-25.975466 11.9808 33.9968 33.9968 0 0 1-24.132267-10.001067l-96.546133-96.546133a34.133333 34.133333 0 0 0-48.264534 0L391.3216 680.96a34.0992 34.0992 0 0 1-50.107733-1.979733c-11.844267-13.806933-9.557333-34.901333 3.310933-47.752534l95.0784-95.0784a34.133333 34.133333 0 0 0 0-48.264533l-95.266133-95.266133c-12.014933-12.014933-14.933333-31.368533-5.000534-45.175467a34.133333 34.133333 0 0 1 51.985067-4.369067l96.546133 96.546134a34.133333 34.133333 0 0 0 48.264534 0l95.266133-95.266134c12.014933-12.014933 31.368533-14.933333 45.175467-5.000533a34.133333 34.133333 0 0 1 4.369066 51.985067l-96.546133 96.546133a34.133333 34.133333 0 0 0 0 48.264533l95.0784 95.061334z"
                p-id="2574"
                data-spm-anchor-id="a313x.7781069.0.i1"
                class="selected"
            ></path>
        </svg>

        <svg
            v-if="name == 'ordering'"
            t="1611395557439"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2106"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M257.141498 320.148507l324.879252 0c15.954367 0 29.006637-13.053294 29.006637-29.006637l0-5.801123c0-15.954367-13.053294-29.007661-29.006637-29.007661l-324.879252 0c-15.954367 0-29.006637 13.053294-29.006637 29.007661l0 5.801123C228.134861 307.095213 241.188154 320.148507 257.141498 320.148507z"
                p-id="2107"
                :fill="color"
            ></path>
            <path
                d="M228.134861 419.062308c0 15.954367 13.053294 29.006637 29.006637 29.006637l324.879252 0c15.954367 0 29.006637-13.053294 29.006637-29.006637l0-5.801123c0-15.954367-13.053294-29.006637-29.006637-29.006637l-324.879252 0c-15.954367 0-29.006637 13.053294-29.006637 29.006637L228.134861 419.062308z"
                p-id="2108"
                :fill="color"
            ></path>
            <path
                d="M737.03015 62.758346 160.972205 62.758346c-52.782134 0-95.723132 42.940998-95.723132 95.723132l0 702.994985c0 52.782134 42.940998 95.723132 95.723132 95.723132l387.471822 0c-20.400632-11.391445-39.353286-25.668613-56.329936-42.645263-6.752798-6.751774-13.063527-13.826913-18.952654-21.170159l-312.190255 0c-17.593703 0-31.907711-14.314007-31.907711-31.908734L129.063471 158.482501c0-17.593703 14.314007-31.907711 31.907711-31.907711L737.03015 126.57479c17.593703 0 31.907711 14.314007 31.907711 31.907711l0 339.049996c22.852474 9.304923 44.325531 21.965268 63.815421 37.72623L832.753281 158.482501C832.753281 105.700367 789.812283 62.758346 737.03015 62.758346z"
                p-id="2109"
                :fill="color"
            ></path>
            <path
                d="M662.72277 851.278193c-0.355087-1.52575-0.821715-3.0208-1.394766-4.476965l-20.405749-65.48034c-1.016143-3.267417-3.778046-5.691629-7.142677-6.26775-3.37691-0.564865-6.79373 0.796132-8.832156 3.533476l-16.712637 22.418592c-14.774495-17.873066-23.508413-40.410362-24.210401-64.611553-0.509606-17.615193-15.219633-31.463596-32.81743-30.971385-17.615193 0.509606-31.482015 15.20326-30.971385 32.81743 0.925069 31.962969 10.781554 62.886259 28.503171 89.426729 6.105045 9.144264 13.06455 17.619286 20.73116 25.360598l-17.188474 23.073508c-2.050706 2.736321-2.388397 6.395664-0.86674 9.470699 1.511423 3.061732 4.623297 5.019317 8.037047 5.054109l103.467513 1.274016c2.064009 0.020466 4.046153-0.657986 5.65172-1.896186 0.648776-0.500397 1.231037-1.101077 1.740644-1.76725 1.730411-2.335185 2.25639-5.366218 1.391696-8.143471L662.72277 851.278193z"
                p-id="2110"
                :fill="color"
            ></path>
            <path
                d="M891.718231 780.538059l-48.244794-91.540879c-0.967024-1.824555-2.508123-3.241834-4.363378-4.062526-0.74906-0.331551-1.555425-0.556679-2.384303-0.686638-2.877537-0.406253-5.792936 0.577145-7.820106 2.662643l-72.119551 74.175373c-2.38635 2.451842-3.199878 6.036483-2.100848 9.268084 1.11438 3.236718 3.940752 5.590322 7.319709 6.076392l24.065092 3.471055c-8.455579 17.35118-21.6286 32.330336-38.554084 43.128263-14.857383 9.477862-19.216667 29.204136-9.740852 44.061518 6.086625 9.540284 16.395412 14.750959 26.930349 14.750959 5.870708 0 11.81407-1.619894 17.130146-5.010107 32.934087-21.0095 56.987922-51.928696 69.350484-87.549985l31.187303 4.487198c3.38305 0.496304 6.759961-0.952698 8.736988-3.756557C893.081275 787.224342 893.316635 783.555789 891.718231 780.538059z"
                p-id="2111"
                :fill="color"
                data-spm-anchor-id="a313x.7781069.0.i1"
                class="selected"
            ></path>
            <path
                d="M741.248218 639.740336c15.468296 8.436136 34.852786 2.738367 43.290969-12.732999 8.438183-15.470343 2.737344-34.852786-12.732999-43.290969-24.833595-13.544481-52.986795-20.702508-81.418334-20.702508-18.49319 0-36.801161 3.055592-54.163597 8.882298l-14.563694-26.213012c-1.65264-2.993171-4.849448-4.805446-8.277524-4.681626-3.412726 0.119727-6.475482 2.152013-7.910157 5.250584l-30.113855 64.681138c-0.349971 0.690732-0.680499 1.388627-0.977257 2.099824l-12.582573 27.025517c-0.86674 1.873674-1.063215 3.959172-0.593518 5.932106 0.189312 0.797156 0.49835 1.574868 0.896416 2.313695 1.418302 2.536776 3.965312 4.26207 6.852058 4.614088l26.549679 3.236718c2.718925 0.731664 5.522784 1.109264 8.335852 1.109264 0.189312 0 0.378623-0.020466 0.567935-0.023536l67.242474 8.197706c3.396353 0.415462 6.741541-1.106194 8.648984-3.936659 1.902326-2.845815 2.065032-6.520507 0.407276-9.504468l-12.681834-22.844288c7.261381-1.539053 14.740726-2.323928 22.363334-2.323928C708.173938 626.828258 725.761502 631.292943 741.248218 639.740336z"
                p-id="2112"
                :fill="color"
            ></path>
        </svg>

        <svg
            v-if="name == 'complete'"
            t="1611396637297"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3101"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M512 960A448 448 0 1 0 512 64a448 448 0 0 0 0 896z m0 64A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z"
                :fill="color"
                p-id="3102"
                data-spm-anchor-id="a313x.7781069.0.i6"
                class="selected"
            ></path>
            <path
                d="M679.552 363.392a32 32 0 1 1 48.896 41.216l-216 256a32 32 0 0 1-46.72 2.368L297.728 500.032a32 32 0 1 1 44.544-45.888l143.36 139.008 193.92-229.76z"
                :fill="color"
                p-id="3103"
            ></path>
        </svg>

        <svg
            v-if="name == 'afterSale'"
            t="1611409116220"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3846"
            :fill="color"
            :width="size"
            :height="size"
        >
            <path
                d="M45.96622222 216.81420515c0-8.55948705 5.3749229-20.11712475 11.69744783-25.52311656L263.44865185 14.8973037v248.55134815l234.64800712 117.33177078c7.68955733 3.83701143 20.03945245 3.88361482 27.80668206 0L760.55134815 263.44865185V14.8973037l205.7849818 176.39378489c6.46233505 5.5302675 11.69744782 16.96362951 11.69744783 25.52311656v435.0269971c0 8.55948705-5.3749229 20.11712475-11.69744783 25.52311657L760.55134815 853.7581037v124.27567408c0 17.16557748-13.82566875 31.06891852-31.09998744 31.06891852H294.54863929A31.00678068 31.00678068 0 0 1 263.44865185 978.03377778v-124.27567408L57.66367005 677.36431882c-6.46233505-5.5302675-11.69744782-16.96362951-11.69744783-25.52311657V216.81420515zM325.58648889 682.87905185c0 17.2743187 13.94994442 31.06891852 31.14659081 31.06891852h310.5338406A31.09998743 31.09998743 0 0 0 698.41351111 682.87905185c0-17.2743187-13.94994442-31.06891852-31.14659081-31.06891852h-310.5338406A31.09998743 31.09998743 0 0 0 325.58648889 682.87905185z"
                p-id="3847"
                :fill="color"
                data-spm-anchor-id="a313x.7781069.0.i1"
                class="selected"
            ></path>
        </svg>

        <!-- <svg
            v-if="name == 'menu_toTravel'"
            t="1612747101872"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1541"
            :width="size"
            :height="size"
            fill="#F0D9AF"
        >
            <path
                d="M857.36 263.9H659.03v-52.88c0-44.05-35.69-79.74-79.74-79.74H444.62c-44.05 0-79.74 35.69-79.74 79.74v52.88H166.64C127.6 263.9 96 295.5 96 334.53v487.56c0 39.03 31.6 70.63 70.63 70.63h690.72c39.03 0 70.63-31.6 70.63-70.63V334.44c0.02-38.94-31.68-70.54-70.62-70.54z m-441.64-52.98c0-15.99 13.01-28.9 28.9-28.9h134.67c15.99 0 28.9 13.01 28.9 28.9v52.88H415.72v-52.88zM711.45 496.8L505.87 702.29c-10.97 10.97-25.56 17.1-41.17 17.1h-0.09c-15.61 0-30.21-6.04-41.26-17.1L311.34 590.21c-6.51-6.51-10.13-15.15-10.13-24.35 0-9.2 3.53-17.84 10.13-24.35 6.51-6.51 15.15-10.13 24.44-10.13 9.2 0 17.84 3.53 24.35 10.04l100.28 100.37c2.32 2.32 6.13 2.32 8.46 0l195.54-195.54c6.51-6.51 15.15-10.04 24.35-10.04 10.78 0 20.73 4.83 27.42 13.48 10.79 14.03 7.81 34.47-4.73 47.11z"
                fill="#F0D9AF"
                p-id="1542"
                data-spm-anchor-id="a313x.7781069.0.i1"
                class="selected"
            ></path>
        </svg> -->

        <svg
            v-if="name == 'menu_toTravel'"
            t="1612747320608"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2387"
            :width="size"
            :height="size"
            fill="#F0D9AF"
        >
            <path
                d="M729.6 448l-294.4 294.4-108.8-115.2c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l134.4 134.4c12.8 12.8 32 12.8 44.8 0l313.6-313.6c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0z"
                p-id="2388"
            ></path>
            <path
                d="M832 128h-102.4L716.8 51.2c-6.4-32-32-51.2-64-51.2H371.2c-32 0-57.6 19.2-64 51.2L294.4 128H192C121.6 128 64 185.6 64 256v640c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128V256c0-70.4-57.6-128-128-128zM371.2 64h281.6l38.4 192H332.8l38.4-192zM896 896c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V256c0-38.4 25.6-64 64-64h89.6l-12.8 64h-44.8c-19.2 0-32 12.8-32 32s12.8 32 32 32h576c19.2 0 32-12.8 32-32s-12.8-32-32-32h-44.8l-12.8-64H832c38.4 0 64 25.6 64 64v640z"
                p-id="2389"
            ></path>
        </svg>

        <svg
            v-if="name == 'menu_afterSale'"
            t="1612690356348"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2162"
            :width="size"
            :height="size"
            fill="#F0D9AF"
        >
            <path
                d="M951.12173955 322.41304355c1.95652177 4.06956533 3.05217422 8.64782578 3.05217334 13.5v465.65217422a148.69565244 148.69565244 0 0 1-148.69565244 148.69565156H218.52173955a148.69565244 148.69565244 0 0 1-148.69565244-148.69565156V335.91304356c0-5.00869599 1.17391289-9.78260888 3.28695644-13.96956534l0.31304356-0.86086934 77.32173867-184.10869599A109.56521778 109.56521778 0 0 1 251.74347822 69.82608711h520.51304355a109.56521778 109.56521778 0 0 1 100.99565245 67.14782578l77.32173867 184.10869599 0.54782666 1.33043468zM891.56521777 367.21739112H132.43478223v434.34782665A86.08695645 86.08695645 0 0 0 218.52173955 887.65217422h586.9565209a86.08695645 86.08695645 0 0 0 86.08695732-86.08695645V367.21739112z m-76.03043555-206.02173868a46.95652177 46.95652177 0 0 0-43.27826044-28.76087022H251.74347822a46.95652177 46.95652177 0 0 0-43.27826044 28.76087022L148.20434756 304.60869599h727.55217422l-60.22173956-143.41304355z"
                p-id="2163"
                data-spm-anchor-id="a313x.7781069.0.i1"
                fill="#F0D9AF"
                class="selected"
            ></path>
            <path
                d="M478.66086933 459.56521778A31.30434756 31.30434756 0 1 0 434.13043467 415.58260888l-94.34347822 95.51739112a35.21739112 35.21739112 0 0 0 25.04347822 59.98695644H551.13043467a86.08695645 86.08695645 0 1 1 0 172.1739129h-195.65217422a31.30434756 31.30434756 0 1 0 0 62.60869599h195.65217422a148.69565244 148.69565244 0 0 0 0-297.39130488H430.37391289l48.28695644-48.91304268z"
                p-id="2164"
                fill="#F0D9AF"
            ></path>
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: "10vw",
        },
        name: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: "#bfa66d",
        },
    },
};
</script>
